import React from "react";
import MuiSvgIcon from "@material-ui/core/SvgIcon";

export default function SvgIcon({ color, fontSize, children, style, className, ...props }) {
  const isMuiFontSize =
    fontSize === "small" ||
    fontSize === "medium" ||
    fontSize === "large" ||
    fontSize === "inherit";

    const customSizeStyle =
    !isMuiFontSize && typeof fontSize === "string"
      ? { fontSize, width: fontSize, height: fontSize }
      : {};

  return (
    <MuiSvgIcon
      color={color}
      fontSize={isMuiFontSize ? fontSize : undefined}
      className={className}
      style={{ ...customSizeStyle, ...style }}
      {...props}
    >
      {children}
    </MuiSvgIcon>
  );
} 